import { Column } from 'react-table';

export function isMenuColumn<TRow extends Record<string, unknown>>(column: Column<TRow>): boolean {
  const { id } = column;

  if (id) {
    return id.toLowerCase().includes('menu');
  }

  return false;
}
